import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useCityPageQuery, useNewsQuery } from "../../api/queries/cityQueries";
import { RichTextBox } from "../../components/richtext/RichTextBox";
import { OverFlowBannerSwiper } from "../../components/swiper/OverFlowBannerSwiper";
import BreadcrumbNavigation from "../../components/product-detail/BreadcrumbNavigation";
import { useTranslationEx } from "../../hooks/useTranslationEx";

const CitiesNewsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: dto } = useCityPageQuery(id ?? "");
  if (!dto) return null;
  return (
    <div className="relative">
      <BreadcrumbNavigation ls={[dto.city.name]} />
      <OverFlowBannerSwiper ls={dto.files} />
      <NewsPageBody />
    </div>
  );
};

export default CitiesNewsPage;

const NewsPageBody = () => {
  const { newsId: newsIdStr } = useParams<{ newsId: string }>();
  const newsId = useMemo(() => parseInt(newsIdStr ?? ""), [newsIdStr]);
  const { data } = useNewsQuery(newsId);
  const { t2 } = useTranslationEx();
  return (
    <div className="ui-container">
      <div className="py-[30px]">
        <h1 className="flex items-center text-2xl font-semibold leading-[33px] text-[#232323]">
          {t2(data?.title)}
        </h1>
      </div>
      <RichTextBox richtext={data?.post?.richtext} />
    </div>
  );
};
